import { videoItems } from "@/mocks/jiuse";

export default function Videos() {
  return (
    <section id="videos" className="scroll-mt-20 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex scroll-mt-24 flex-col gap-3 border-b-2 border-foreground-950 pb-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-[0.26em] text-primary-700">
              <i className="ri-play-circle-line text-sm" aria-hidden="true" />
              影库 · 动态专区
            </p>
            <h2 className="font-display text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">九色黑料视频，动态细节比截图更清楚</h2>
          </div>
          <p className="flex items-center gap-2 whitespace-nowrap text-[13px] text-foreground-600">
            <i className="ri-time-line text-primary-600" aria-hidden="true" /> 持续补入 · 画质修复版标注中
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 xl:grid-cols-2">
          {videoItems.map((it) => (
            <article
              key={it.title}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:border-primary-300"
            >
              <a href="#videos" className="flex h-full flex-col sm:flex-row">
                <div className="relative shrink-0 overflow-hidden bg-background-200 sm:w-[42%]">
                  <img
                    src={it.cover}
                    alt={`${it.title} - 九色黑料视频`}
                    title={`${it.title} 九色黑料视频`}
                    className="h-52 w-full object-cover transition duration-500 group-hover:scale-105 sm:h-full"
                  />
                  <span className="absolute inset-0 grid place-items-center">
                    <span className="grid h-12 w-12 place-items-center rounded-full bg-primary-600 text-xl text-background-50 shadow ring-4 ring-background-50/60 transition group-hover:bg-primary-700">
                      <i className="ri-play-fill ml-0.5" aria-hidden="true" />
                    </span>
                  </span>
                  <span className="absolute bottom-2 right-2 rounded bg-foreground-950/75 px-1.5 py-0.5 text-[11px] font-medium text-background-50">
                    {it.duration}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="mb-2 flex items-center gap-2">
                    <span className="rounded-full bg-secondary-600 px-2.5 py-0.5 text-[11px] font-semibold text-background-50">{it.tag}</span>
                    <span className="flex items-center gap-1 text-[11px] text-foreground-500"><i className="ri-eye-line" aria-hidden="true" />{it.views}</span>
                  </div>
                  <h3 className="font-display text-[17px] font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700">{it.title}</h3>
                  <p className="mt-2 text-[13px] leading-6 text-foreground-600">{it.summary}</p>
                  <span className="mt-auto flex items-center gap-1 pt-3 text-[12px] font-medium text-primary-700">
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true" />进入视频页看动态
                  </span>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}